import React, { useState, useContext, useEffect } from "react";
import "./Login.scss";
import Form from "react-bootstrap/Form";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { userContext } from "../../context/Auth";
import { Spinner } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { generateToken, messaging } from "../../components/firebase/firebase";
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";
import { onMessage } from "firebase/messaging";

const realStoredValue = (value) => {
    if (!value || value === "null" || value === "undefined") return "";
    return value;
};

const signedInDashboardPath = () => {
    if (realStoredValue(localStorage.getItem("user_id"))) return "/home";
    if (
        realStoredValue(localStorage.getItem("virtualmall_token")) &&
        realStoredValue(localStorage.getItem("virtual_user_id"))
    ) {
        return "/user-points";
    }
    return "";
};

const Login = () => {
    const {
        formData,
        setFormData,
        loginSubmit,
        ToastContainer,
        userlogin,
        setUserlogin,
    } = useContext(userContext);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const navigate = useNavigate();
    const dashboardPath = signedInDashboardPath();

    useEffect(() => {
        if (!dashboardPath) return;
        navigate(dashboardPath, { replace: true });
    }, [dashboardPath, navigate]);

    const onHandleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [id]: value,
        }));
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    // const [AdImages, setAdImages] = useState([]);

    useEffect(() => {
        onMessage(messaging, (payload) => {
            console.log(payload, 'payloaddddd')
            toast.success(payload.notification.body)
        });
        generateToken();
    }, []);

    // useEffect(() => {
    //     if (userlogin) {
    //       AdsCount();
    //     }
    //   }, [userlogin]);


    // Registering the service worker
    //  if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker
    //     .register('../../../public/firebase-messaging-sw', { scope: '/' }) // Register with the correct scope
    //     .then((registration) => {
    //       console.log('Service Worker registered successfully:', registration);
    //     })
    //     .catch((error) => {
    //       console.error('Service Worker registration failed:', error);
    //     });
    // }



    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker
                .register('/firebase-messaging-sw.js')
                .then((registration) => {
                    console.log('Service Worker registered with scope:', registration.scope);
                })
                .catch((error) => {
                    console.error('Service Worker registration failed:', error);
                });
        });
    }

    const AdsCount = async () => {
        try {
            const response = await axios.get(
                `${APP_BASE_URL}/vitual_mall/ads/count`,
                {}
            );

            if (response?.data?.result) {
                console.log(response.data.data, 'count')
                // setAdImages(response.data.data || []);
            } else {
                toast.error("Failed to load ads");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to load ads");
        }
    };

    // const Adlist = async () => {
    //   try {
    //     const response = await axios.post(
    //       `https://api.springwayhub.com/mlm/ads/list`,
    //       {}
    //     );

    //     if (response?.data?.result) {
    //       console.log(response.data.data, 'pppp')
    //       setAdImages(response.data.data || []);
    //     } else {
    //       toast.error("Failed to load ads");
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     toast.error("Failed to load ads");
    //   }
    // };

    // const renderAd = (index) => {
    //   if (!AdImages[index]) {
    //     return null; // Don't render anything if undefined
    //   }
    //   console.log(index, AdImages[index], 'index1234', AdImages[index].ad_image)

    //   return (
    //     //border: "2px solid white",
    //     <div style={{ padding: "5px", textAlign: "center" }} className="advertisement">
    //       <img className="ad-image"
    //         style={{ width: "200px", height: "200px" }}
    //         src={`https://api.springwayhub.com/${AdImages[index].ad_image}`}
    //         alt={`Ad ${index + 1}`}
    //         onError={(e) => {
    //           e.target.src = './images/main_logo.png';
    //           e.target.onerror = null;
    //         }}
    //       />
    //     </div>
    //   );
    // };

    if (dashboardPath) {
        return null;
    }

    return (
        <div className="container-fluid logins">
            {/* <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {[0, 1, 2, 3].map(index => renderAd(index))}
      </div> */}
            <form onSubmit={loginSubmit} className="ad-form">
                <h4>Log In</h4>
                <div className="logo">
                    <img src="./images/main_logo.png" alt="" />
                </div>

                <div className="log-inputs">
                    <div>
                        <Form.Label htmlFor="email">User Id</Form.Label>
                        <Form.Control
                            type="text"
                            name="referral_id"
                            onChange={onHandleChange}
                            id="referral_id"
                            value={formData.referral_id}
                            placeholder="Enter your referral id"
                        />
                    </div>

                    <div className="password">
                        <Form.Label htmlFor="password">Password</Form.Label>
                        <Form.Control
                            type={passwordVisible ? "text" : "password"}
                            id="password"
                            name="password"
                            onChange={onHandleChange}
                            value={formData.password}
                            placeholder="Enter your password"
                        />
                        <div onClick={togglePasswordVisibility}>
                            {passwordVisible ? (
                                <FaEyeSlash className="closedeyes" />
                            ) : (
                                <FaEye className="openeyes" />
                            )}
                        </div>
                        <NavLink to="/forgot">
                            <div className="forgot">Forgot password?</div>
                        </NavLink>
                    </div>
                </div>
                <button type="submit" disabled={userlogin}>
                    {userlogin ? (
                        <>
                            <Spinner animation="grow me-2" />
                            Loging....
                        </>
                    ) : (
                        "Log in"
                    )}
                </button>

                <NavLink to="/register">
                    <h6>Register an account</h6>
                </NavLink>
            </form>
            {/* <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {[4, 5, 6, 7].map(index => renderAd(index))}
      </div> */}
            <ToastContainer />
        </div>
    );
};

export default Login;